import { createForm } from "../../../Common/EditProfile/formContext";
import { License } from "../../../api/vet";

export type RegistrationLicenseFormType = {
  licenses: License[];
  deletedLicenses?: [];
  // Tech fields
  isCertified?: boolean;
  isRegistered?: boolean;
  isLicensed?: boolean;
  isVTS?: boolean;
};

export const { useFormContext, FormProvider } = createForm<RegistrationLicenseFormType>();
